var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C2C2C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,8.8H5.2C4.8,8.8,4.5,8.4,4.5,8s0.3-0.8,0.8-0.8H9c0.4,0,0.8,0.3,0.8,0.8S9.4,8.8,9,8.8z M14.7,11.8H5.2 c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h9.5c0.4,0,0.8,0.3,0.8,0.8S15.1,11.8,14.7,11.8z M14.7,14.8H5.2c-0.4,0-0.8-0.3-0.8-0.8 s0.3-0.8,0.8-0.8h9.5c0.4,0,0.8,0.3,0.8,0.8S15.1,14.8,14.7,14.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,1.5l6.2,6.2C16.9,7.8,17,8,17,8.2v9.6c0,0.4-0.3,0.8-0.8,0.8H3.8c-0.4,0-0.8-0.3-0.8-0.8V2.2 c0-0.4,0.3-0.8,0.8-0.8H10.6 M11.2,0H3C2.2,0,1.5,0.7,1.5,1.5v17C1.5,19.3,2.2,20,3,20h14c0.8,0,1.5-0.7,1.5-1.5V7.2L11.2,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,3.6l2.1,2.1h-2.1V3.6 M11.2,0v6.5c0,0.4,0.3,0.8,0.8,0.8h6.5L11.2,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.c1974f85.svg";
export { ForwardRef as ReactComponent };